import { TextField } from "@mui/material";
import React from "react";

function PrimaryTextBox(props) {
    return <TextField size="medium" name={props.name} id="outlined-basic" label={props.label} variant="outlined" style={{ width: "100%" }} onChange={props.onChange} required />
}

export default PrimaryTextBox;